<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

const emit = defineEmits<{
  verified: [token: string]
}>()

const container = ref<HTMLElement | null>(null)
const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY || ''
let widgetId = ''
let poll: number | undefined

function renderWidget() {
  if (!siteKey || !container.value || !window.turnstile || widgetId) return
  widgetId = window.turnstile.render(container.value, {
    sitekey: siteKey,
    theme: 'light',
    callback: (token) => emit('verified', token),
    'expired-callback': () => emit('verified', ''),
    'error-callback': () => emit('verified', ''),
  })
}

onMounted(() => {
  if (!siteKey) {
    emit('verified', 'development-disabled')
    return
  }
  if (!document.querySelector('script[data-turnstile]')) {
    const script = document.createElement('script')
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
    script.async = true
    script.defer = true
    script.dataset.turnstile = 'true'
    script.addEventListener('load', renderWidget)
    document.head.appendChild(script)
  }
  poll = window.setInterval(renderWidget, 250)
})

onBeforeUnmount(() => {
  if (poll) window.clearInterval(poll)
  if (widgetId) window.turnstile?.reset(widgetId)
})
</script>

<template>
  <div v-if="siteKey" ref="container" class="turnstile" aria-label="人机验证"></div>
  <p v-else class="development-note">本地开发环境暂未启用人机验证。</p>
</template>

